<template>
  <div class="rt-view-wrapper">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'RtView'
};
</script>



// WEBPACK FOOTER //
// rtView.vue?0d59a6bc